import {APIClient} from '../../utils/APIClient';
import {API_URL} from '../../settings/local_settings';

// Ping de copiado de un prompt oficial de la matriz: registra QUÉ variante y QUÉ versión
// copió la agencia (la métrica de adopción stub vs pack, y la base del chip "v9 disponible").
// Fire-and-forget dentro del `.then` del clipboard (patrón PromptLibraryCard): si falla, la
// copia ya ocurrió y no se molesta al usuario — APIClient resuelve NETWORK_ERROR, no rechaza.
export function pingPromptCopied(promptId, {version, agencyClientId} = {}) {
    if (!promptId) return;
    const body = {};
    if (version) body.version = version;
    if (agencyClientId) body.agency_client_id = agencyClientId;
    new APIClient(`${API_URL}agent/prompts/${encodeURIComponent(promptId)}/copied/`)
        .call('POST', body);
}

// Estado "qué versión tiene pegada MI agencia" por prompt oficial ({statuses: {id: {...}}}).
// Con `agencyClientId`, las copias hechas PARA ese cliente (la ficha copia el prompt
// mono-cliente por cliente). Ante cualquier error devuelve {} — el chip simplemente no aparece.
export function fetchPromptCopyStatus({agencyClientId} = {}) {
    const params = agencyClientId
        ? `?agency_client_id=${encodeURIComponent(agencyClientId)}`
        : '';
    return new APIClient(`${API_URL}agent/prompts/copy-status/${params}`).call('GET')
        .then(response => (response && response.statuses) || {})
        .catch(() => ({}));
}

// El copyStatus después de una copia (update optimista): el chip acompaña al "Copiado ✓" al
// instante. Definición ÚNICA para las tres superficies que lo aplican (/dashbo-mcp y las dos
// fichas del cliente) — triplicada, ya había empezado a necesitar el mismo fix tres veces.
//
// `current_version` NUNCA se sintetiza (review A-H3, 2026-08-11): si copy-status no respondió
// (caído o todavía en vuelo), no sabemos cuál es la versión vigente — afirmar "Al día" con la
// versión recién copiada mentiría cuando la lista de prompts del browser quedó vieja. Sin
// `current_version`, PromptVersionBadge no renderiza: esconder el chip antes que mentir.
// Cuando copy-status SÍ respondió, trae `current_version` hasta para prompts nunca copiados,
// así que el caso normal conserva el chip. Si el ping falla no se revierte: el reload reconcilia.
export function copyStatusAfterCopy(prev, promptId, version) {
    if (!promptId || !version) return prev;
    const previous = prev[promptId] || {};
    return {
        ...prev,
        [promptId]: {
            current_version: previous.current_version,
            last_copied_version: version,
            last_copied_at: new Date().toISOString(),
        },
    };
}
